import { jsx as r } from "react/jsx-runtime";
import { c as m } from "../../clsx-OuTLNxxd.js";
const _ = "FormRow-module_row__dNnTE",
  s = "FormRow-module_col1__FVwk4",
  t = "FormRow-module_col2__k5hKJ",
  w = "FormRow-module_col3__b66PA",
  o = {
    row: _,
    col1: s,
    col2: t,
    col3: w
  },
  n = _ref => {
    let {
      columns: c = "1",
      children: l
    } = _ref;
    return /* @__PURE__ */r("div", {
      className: m(o.row, {
        [o.col1]: c == "1",
        [o.col2]: c == "2",
        [o.col3]: c == "3"
      }),
      children: l
    });
  };
export { n as FormRow };